import React from 'react';
import { init } from '@dash0/sdk-web';
import type { UrlAttributeRecord } from '@dash0/sdk-web';

const DASH0_INGRESS_URL = 'https://ingress.us-west-2.aws.dash0.com';

const redactSensitiveUrlParams = (value: string) =>
  value
    .replace(/key=[A-Za-z0-9_-]+/g, 'key=[REDACTED]')
    .replace(/token=[A-Za-z0-9_-]+/g, 'token=[REDACTED]')
    .replace(/secret=[A-Za-z0-9_-]+/g, 'secret=[REDACTED]');

const urlAttributeScrubber = (attributes: UrlAttributeRecord): UrlAttributeRecord => {
  const scrubbedAttributes = { ...attributes };

  if (scrubbedAttributes['url.query']) {
    scrubbedAttributes['url.query'] = redactSensitiveUrlParams(scrubbedAttributes['url.query']);
  }

  if (scrubbedAttributes['url.full']) {
    scrubbedAttributes['url.full'] = redactSensitiveUrlParams(scrubbedAttributes['url.full']);
  }

  return scrubbedAttributes;
};

if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_ENABLE_DASH0 === 'true') {
  init({
    serviceName: 'portals-enrollment-client',
    endpoint: {
      url: DASH0_INGRESS_URL,
      authToken: `${process.env.NEXT_PUBLIC_OTEL_TOKEN}`,
    },
    environment: process.env.NEXT_PUBLIC_VERCEL_ENV,
    deploymentName: process.env.NEXT_PUBLIC_VERCEL_TARGET_ENV,
    deploymentId: process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL,
    urlAttributeScrubber,
    propagators: [
      {
        type: 'traceparent',
        match: [
          /\/api\/.*/,
          /^https:\/\/graphql\.(prod|uat|qa|stg)\.evgo\.com.*$/,
          /^https:\/\/(internal-api|api)\.(prod|uat|qa|stg)\.evgo\.com.*$/,
        ],
      },
    ],
  });
}

export const OTELProvider = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};
